import { IClients, IGetClientBySuperuserQueryResponse } from '@/types/User';
import { baseApi } from './base';

interface CreateUserRequest {
  email: string;
  user_name: string;
  name: string;
  nick_name: string;
  password: string;
  role: string;
  database: string;
  client_id: string;
}

interface CreateUserResponse {
  success: boolean;
  user_id?: string;
  message?: string;
}

interface User {
  user_id: string;
  name: string;
  email: string;
  superuser: string;
  created_at?: string;
  updated_at?: string;
}

interface GetUsersResponse {
  users: User[];
  total?: number;
}

interface UpdateUserRequest {
  name?: string;
  role?: string;
}

interface UpdateUserResponse {
  success: boolean;
  message?: string;
}

export const usersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSuperuserClients: builder.query<IClients, void>({
      query: () => ({ url: '/api/v2/superusers/clients' }),
      transformResponse: (response: IGetClientBySuperuserQueryResponse) => response.databases,
      providesTags: ['User'],
    }),
    getUsers: builder.query<GetUsersResponse, void>({
      query: () => ({
        url: '/api/v3/users',
        method: 'GET',
      }),
      providesTags: ['User'],
    }),
    createUser: builder.mutation<CreateUserResponse, CreateUserRequest>({
      query: (body) => ({
        url: '/api/v3/users',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    updateUser: builder.mutation<UpdateUserResponse, { userId: string; body: UpdateUserRequest }>({
      query: ({ userId, body }) => ({
        url: `/api/v3/users/${userId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetSuperuserClientsQuery,
  useGetUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
} = usersApi;
